import script from "./CustomAttribut.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomAttribut.vue?vue&type=script&lang=ts&setup=true"

import "./CustomAttribut.vue?vue&type=style&index=0&id=32f738a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32f738a8"]])

export default __exports__